export default __webpack_public_path__ + "fd9d70655578c22c748b499c95b9af0c.png";